module.exports = __webpack_public_path__ + "static/media/bank.ce6f1d86.svg";